import { render } from "./AddSharedCollectionPopup.vue?vue&type=template&id=3ca20a9e&scoped=true"
import script from "./AddSharedCollectionPopup.vue?vue&type=script&lang=js"
export * from "./AddSharedCollectionPopup.vue?vue&type=script&lang=js"

import "./AddSharedCollectionPopup.vue?vue&type=style&index=0&id=3ca20a9e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca20a9e"]])

export default __exports__